import { Portal } from "@circle-react-uikit/Portal";

import {
  STANDARD_LAYOUT_HEADER_ID,
  standardLayoutHeaderSelector,
} from "../constants";
import { PageHeader, type PageHeaderProps } from "./Header";

const childId = `${STANDARD_LAYOUT_HEADER_ID}-child`;

export const PageHeaderWithPortal = ({
  children,
  ...props
}: PageHeaderProps) => (
  <Portal selectorQuery={standardLayoutHeaderSelector}>
    <PageHeader {...props} id={childId} />
    {children}
  </Portal>
);
